<template>
  <div class>
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="handleChangeDrawer">
      <div slot="body">
        <div class="pay-mains">
          <el-form
            ref="form"
            class="demo-ruleForm"
            label-width="170px"
            label-position="left"
          >
            <div class="align-items">
              <p class="order-title-boxs">
                <span class="blueBlock"></span><i>顾客信息</i>
              </p>
              <span @click="handMember" class="jishi fontSize16 pr16 cur">选择会员(可选)</span>
            </div>
            <div class="memberInfo" v-show="memberFlag">
              <member ref="member" :mobile="formMobile" @handleUser="memberChange"></member>
            </div>
            <el-row>
              <el-col :span="12">
                <el-form-item
                  label="顾客姓名："
                  required=""
                  class="el-form-item-update"
                >
                  <el-input v-model.trim="form.customerName" :disabled="disabledName" placeholder="请输入顾客姓名" maxlength="5"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="手机号："
                  required=""
                  class="el-form-item-update"
                >
                  <el-input v-model.trim="form.mobile" :disabled="disabled" placeholder="请输入手机号码" @blur="numberEnter" maxlength="11"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item
                  label="备注："
                  required=""
                  class="el-form-item-update"
                >
                  <el-input v-model="form.remark" type="textarea" placeholder="请输入备注" maxlength="150" show-word-limit></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="align-items">
          <p class="order-title-boxs">
            <span class="blueBlock"></span><i>赠品明细</i>
          </p>
          <span class="jishi fontSize16 pr16 cur" @click="seletGift">选择赠品</span>
        </div>
        <div class="contents-body" v-if="selectList.length != 0">
          <el-row class="tables-title">
            <el-col :span="12" class="titles pl10">商品名称</el-col>
            <el-col :span="6" class="titles center">单价(元)</el-col>
            <el-col :span="4" class="titles center">赠送数量</el-col>
            <el-col :span="2" class="titles center">操作</el-col>
          </el-row>
          <div class="tables p30 scroll-auto">
            <div class="boxs" v-for="(item, index) in selectList" :key="index">
              <el-row>
                <el-col :span="12" class="titles pl10">{{ item.name }}</el-col>
                <el-col :span="6" class="money center">
                  ￥{{ item.salePrice }}
                </el-col>
                <el-col :span="4" class="nums center">
                  <span class="del-img" @click="blurItem('del',  item)">
                    <img src="../../../assets/images/new/del.png" alt="">
                  </span>
                  <el-input v-model="item.itemNum" readonly="" size="mini" style="width: 40px;"></el-input>
                  <span class="del-img" @click="blurItem('add',item)">
                    <img src="../../../assets/images/new/add.png" alt="">
                  </span>
                  <!-- <el-input-number
                    v-model="item.itemNum"
                    @blur="blurItem(item)"
                    :min="1"
                  ></el-input-number> -->
                </el-col>
                <el-col :span="2" class="detail right">
                  <i class="el-icon-delete delete" @click="deleteListSelected(item, index)"></i>
                </el-col>
              </el-row>
              <div class="right-content p10">
                <span class="staff-btn mr10 pl10">服务技师</span>
                <span v-if="!item.staffNames" @click="setStaff(item, index)" class="shopClass">请选择></span>
                <span v-else  @click="setStaff(item, index)" class="shopClass">
                  {{item.staffNames}}
                </span>
              </div>
            </div>
          </div>
        </div>
        <!-- <el-table :data="selectList" max-height="280" border v-if="selectList.length != 0">
          <el-table-column prop="name" label="商品名称"></el-table-column>
          <el-table-column prop="salePrice" label="售价" width="80"></el-table-column>
          <el-table-column prop="itemNum" label="数量" width="80">
            <template slot-scope="scope">
                <el-input v-model.number="scope.row.itemNum" @blur="itemNum(scope.row.itemNum)"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="auto">
            <template slot-scope="scope">
              <el-link type="success" @click="setStaff(scope.row,scope.$index)">{{scope.row.staffNames ? scope.row.staffNames :"选择技师"}}</el-link>
            </template>
          </el-table-column>
        </el-table> -->
        <div class="drawer-footer pr24 pb10">
          <div class="btns">
            <el-button type="primary" class="ml10" @click="save">确定赠送</el-button>
          </div>
        </div>
      </div>
    </drawer>
    <selectGift ref="selectGift" @changeGift="giftCallback"></selectGift>
    <staff-set ref="staffSetForm" :isCashier="true" @staffChange="changePage"></staff-set>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import drawer from "../../../components/common/drawer";
import member from "../../components/member";
import selectGift from "./selectGift.vue"
import staffSet from "../../components/staff-set";
import { decrypt, encrypt } from "../../../assets/javascript/untils";
export default {
  mixins: [minxin],
  components: { drawer ,member, selectGift , staffSet},
  data() {
    return {
      addEditTitle: "新增开支",
      addEditShow: false,
      options: [],
      form: {
        memberId: "",
        customerName: "",
        mobile: ""
      },
      formMobile: "",
      memberFlag: false,
      selectList: [],
      staffIndex: null,
      disabled: false,
      disabledName: false
    };
  },
  created() {
    this.editInit();
  },
  methods: {
    back() {
      this.formMobile = "";
      this.$refs['member'].clearMember();
      this.$refs['form'].resetFields();
      this.addEditShow = false;
    },
    editInit() {
      this.$on("set", function(org) {
        Object.assign(this.$data, this.$options.data());
        this.addEditTitle = "添加赠品" 
        this.addEditShow = true;
      });
    },
    memberChange(value) {
      this.form.memberId = value.id;
      this.form.customerName = value.realName;
        this.form.idCardNo = value.idCardNo;
      this.form.mobile = value.mobile;
      console.log(this.form)
      if (this.form.memberId) {
        this.disabledName = true;
      } else {
        this.disabledName = false;
      }
      if (this.form.mobile && !this.form.idCardNo) {
        this.disabled = true;
      } else if (this.form.idCardNo && !this.form.mobile){
        this.disabled = false;
      } else if (this.form.mobile && this.form.idCardNo) {
          this.disabled = true;
      } else {
        this.disabled = false; 
      }
      this.memberFlag = false;
      
    },
    handMember () {
        // 选择会员
      this.memberFlag = true;
      if (this.form.memberId) {
        this.$refs['member'].clearMember();
        this.form = {};
        this.disabledName = false;
        this.disabled = false;
      } 
    },
    setStaff(row, index) {
        // 选择技师
        this.$set(row, "staffIds" , true)
        this.staffIndex = index;
        this.$refs["staffSetForm"].$emit("set", {
            staffIds: row.staffId,
            index: index
        });
    },
    changePage(org) {
         // 选择技师 -- 回调
        if (org) {
            let id = [];
            let name = []
            org.staffIds.map(item => {
                id.push(item.staffId);
                name.push(item.staffName)
            })
            id = id.join(",")
            name = name.join(",")
            this.$set(this.selectList[this.staffIndex], 'staffIds', id)
            this.$set(this.selectList[this.staffIndex], 'staffId', org.staffIds)
            this.$set(this.selectList[this.staffIndex], 'staffNames', name)
        }
    },
    seletGift () {
        // 选择赠品
        this.$refs["selectGift"].$emit("set", this.selectList);
    },
    giftCallback (org) {
        // 选择赠品回调函数
        console.log(org)
        if (org) this.selectList = this.selectList.concat(org);
        this.selectList.map(item => {
            item.itemId = item.id;
            this.$set(item, 'itemNum', item.itemNum ? item.itemNum : 1)
            // item.itemNum = item.itemNum ? item.itemNum : 0
        })
        console.log(this.selectList)
        
    },
    // 失去焦点的时候 数量变为1
    blurItem(type,item) {
      if (type == 'del') {
        if (item.itemNum > 1) item.itemNum--;
      } else {
        if (item.itemNum >= 99) return
        item.itemNum++;
      }
      this.handleChangeInput();
		},
    // blurItem (item) {
    //   if (!item.itemNum) {
    //     item.itemNum = Number(1)
    //     this.handleChangeInput();
    //   }
    // },
    deleteListSelected(item, index) {
      item.itemNum = Number(1)
      this.selectList.splice(index, 1);
    },
    handleChangeDrawer() {
      this.$refs['member'].clearMember();
      this.$refs["form"].clearValidate();
      this.addEditShow = false;
      this.$emit("change", false);
    },
    numberEnter () {
        // var re = /^1[3456789]\d{9}$/;
        // if (!re.test(this.form.mobile)) {
        //     this.$message.error("请输入正确的手机号码")
        // }
         if (this.form.mobile && this.form.mobile.length != 11) {
            this.$message.error("请输入正确的手机号码")
        }
    },
    save() {
        // var re = /^1[3456789]\d{9}$/;
        console.log(!this.form.mobile && !this.disabled && !this.form.idCardNo)
        if (!this.form.customerName) {
            return this.$message.error("请输入顾客姓名")
        } else if (!this.form.mobile && !this.disabled && !this.form.idCardNo) {
            return this.$message.error("请输入手机号码")
        } else if (this.form.mobile && this.form.mobile.length != 11) {
           return this.$message.error("请输入正确的手机号码")
        } else if (!this.form.remark) {
            return this.$message.error("请输入备注")
        } else if (this.selectList.length == 0) {
            return this.$message.error("请选择赠品")
        }
        for (let i = 0; i < this.selectList.length; i++) {
            if (!this.selectList[i].staffNames) {
                return this.$message.error("请选择技师")
            }
        }
    
        this.form.orderItemList = this.selectList;
        this.form.millisecond = new Date().getTime();
        
        let arr = encrypt(JSON.stringify(this.form));
        this.$api.post(this.$url.giftOrderInfo.save, arr).then(res => {
            if (res) {
                this.addEditShow = false;
                this.selectList = [];
                this.$refs['member'].clearMember();
                this.$message.success("赠送成功");
                this.$emit("change", true);
            }
        })
        .catch(error => {});

    }
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
  .contents-body {
      .center {
        text-align: center;
      }
      .right {
        text-align: right;
      }
      .tables-title {
        font-size: 14px;
        margin: 0 16px;
        padding: 10px 0;
        font-size: 16px;
        font-weight: 600;
        background: #F7F8FA;
      }
      .tables {
        padding: 0 16px 0;
        max-height: 150px;
        box-sizing: border-box;
        .boxs {
          min-height: 65px;
          padding: 24px 0;
          box-sizing: border-box;
          border-bottom: 1px solid #EBEDF0;
          .titles {
            font-weight: 500;
          }
          .money {
            color: @money;
            font-weight: 500;
          }
          .nums {
            /deep/.el-input-number {
              width: 80px;
              .el-input__inner {
                padding: 0 25px;
                height: 22px;
                line-height: 22px;
              }
            }
          }
          .delete {
            font-size: 18px;
            cursor: pointer;
            &:hover {
              color: @blue;
            }
          }
        }
        .right-content {
          margin-top: 20px;
          display: flex;
          justify-content: space-between;
          .staff-btn {
            display: inline-block;
            text-align: center;
            color: #8d8d8d;
          }
        }
      }
    }
  .memberInfo {
    padding: 0 20px;
  }
.pay-mains {
  padding: 0;
  overflow: hidden;
}
.nums {
  display: flex;
  justify-content: center;
  .del-img {
    width: 28px;
    height: 28px;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
    }
  }
  /deep/ .el-input__inner {
    border-radius: inherit;
    text-align: center;
    padding: 0;
    border-left: none;
    border-right: none;
  }
}
</style>